import { useEffect } from "react";
import type { AssistantRuntime } from "@assistant-ui/react";

/**
 * Names the agent that serves every turn of this runtime. The AG-UI adapter
 * spreads model-context `config` into the request's `forwardedProps`, so the
 * analysis-agent reads it as `forwardedProps.agent_id` — the same channel
 * `forwardedProps.connectors` rides (see the Composer's connector forwarding).
 */
export function useForwardAgentId(
  runtime: Pick<AssistantRuntime, "registerModelContextProvider">,
  agentId: string
): void {
  useEffect(() => {
    return runtime.registerModelContextProvider({
      getModelContext: () => ({
        config: { agent_id: agentId } as any, // eslint-disable-line @typescript-eslint/no-explicit-any
      }),
    });
  }, [runtime, agentId]);
}
